import { Localization } from "../../../common/localizable-component";
import { ButtonLocalization } from "./button-types";

export const BUTTON_LOCALIZATION: Localization<ButtonLocalization> = {
  en: {
    ariaLabel: {
      phone: "Call phone number {0}",
      mail: "Send a mail to {0}",
      download: "Download {0}",
      default: "Navigate to {0}"
    }
  },
  de: {
    ariaLabel: {
      phone: "Rufe {0} an",
      mail: "Verfasse eine E-Mail an {0}",
      download: "{0} herunterladen",
      default: "Navigiere zu {0}"
    }
  },
  sv: {
    ariaLabel: {
      phone: "Ring telefonnummer {0}",
      mail: "Skicka ett mail till {0}",
      download: "Ladda ner {0}",
      default: "Navigera till {0}"
    }
  },
  nl: {
    ariaLabel: {
      phone: "Bel telefoonnummer {0}",
      mail: "Stuur een e-mail naar {0}",
      download: "Download {0}",
      default: "Navigeer naar {0}"
    }
  }
};
